import { ValueOf } from '../types';

export const OS = {
  WINDOWS: 'WINDOWS',
  MAC: 'MAC',
  LINUX: 'LINUX',
  ANDROID: 'ANDROID',
  IOS: 'IOS',
  UNKNOWN: 'UNKNOWN',
} as const;

export function getOS(): ValueOf<typeof OS> {
  if (typeof navigator === 'undefined') return OS.UNKNOWN;

  if (navigator.userAgent.indexOf('Win') != -1) return OS.WINDOWS;
  if (navigator.userAgent.indexOf('Android') != -1) return OS.ANDROID;
  if (navigator.userAgent.indexOf('like Mac') != -1) return OS.IOS;
  if (navigator.userAgent.indexOf('Mac') != -1) return OS.MAC;
  if (navigator.userAgent.indexOf('Linux') != -1) return OS.LINUX;

  return OS.UNKNOWN;
}
